import { Deserializable } from '../protocols/deserializable';
import { AccountType } from '../transactions/account-type';
import { AccountStatusEnum } from '../transactions/enum/account-status.enum';

export class PaymentMethodVariableBenefitUsage implements Deserializable {
  public accountId!: number;
  public accountType!: AccountType;
  public accountStatusId!: AccountStatusEnum;

  onDeserialize(): void {
    if (this.accountType) {
      this.accountType = window?.injector?.Deserialize?.instanceOf(AccountType, this.accountType);
    }
  }
}
